import BaseService from '../../base/base_service';
import DOM from '../../utils/dom';
import IScriptLoaderService from './script_loader_service_interface';

export default class ScriptLoaderService extends BaseService implements IScriptLoaderService {
    static CLASS = 'ScriptLoaderService'

    loadScript(url: string, tagId?: string): Promise<void> {

        return new Promise<void>((resolve, reject) => {
            let loadScriptWithRetry = (retryCount: number) => {
                let scriptTag = document.createElement('script');
                const ignoreOneTrustAtt = document.createAttribute("data-ot-ignore");
                scriptTag.setAttributeNode(ignoreOneTrustAtt);
                scriptTag.id = tagId;
                scriptTag.src = url;
                scriptTag.onload = () => resolve();
                scriptTag.onerror = (err) => {
                    document.body.removeChild(scriptTag);
                    if(retryCount === 0) {
                        reject(err);
                        this.logger.error(`Failed to load script: ${url}`);

                    } else {
                        DOM.setTimeout(() => loadScriptWithRetry(retryCount - 1), 500);
                    }
                };

                document.body.appendChild(scriptTag);
            };

            loadScriptWithRetry(6);
        });
    }
}
